/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Game derived from competitions or social profiles
 * @export
 * @interface DerivedGameResponse
 */
export interface DerivedGameResponse {
    /**
     * OWGame ID or platform-specific ID
     * @type {string}
     * @memberof DerivedGameResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof DerivedGameResponse
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof DerivedGameResponse
     */
    thumbnailUrl?: string;
    /**
     * Where the game was derived from
     * @type {string}
     * @memberof DerivedGameResponse
     */
    source?: DerivedGameResponseSourceEnum;
    /**
     * Platform name if source is social (e.g., "twitch", "youtube")
     * @type {string}
     * @memberof DerivedGameResponse
     */
    sourcePlatform?: string;
}


/**
 * @export
 */
export const DerivedGameResponseSourceEnum = {
    competition: 'competition',
    social: 'social'
} as const;
export type DerivedGameResponseSourceEnum = typeof DerivedGameResponseSourceEnum[keyof typeof DerivedGameResponseSourceEnum];


/**
 * Check if a given object implements the DerivedGameResponse interface.
 */
export function instanceOfDerivedGameResponse(value: object): value is DerivedGameResponse {
    return true;
}

export function DerivedGameResponseFromJSON(json: any): DerivedGameResponse {
    return DerivedGameResponseFromJSONTyped(json, false);
}

export function DerivedGameResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DerivedGameResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'thumbnailUrl': json['thumbnailUrl'] == null ? undefined : json['thumbnailUrl'],
        'source': json['source'] == null ? undefined : json['source'],
        'sourcePlatform': json['sourcePlatform'] == null ? undefined : json['sourcePlatform'],
    };
}

export function DerivedGameResponseToJSON(json: any): DerivedGameResponse {
    return DerivedGameResponseToJSONTyped(json, false);
}

export function DerivedGameResponseToJSONTyped(value?: DerivedGameResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'thumbnailUrl': value['thumbnailUrl'],
        'source': value['source'],
        'sourcePlatform': value['sourcePlatform'],
    };
}

